export default {
  getStatus (contract) {
    if (contract.accepted_at === null) {
      return {
        color: 'warning',
        icon: 'fa-warning',
        text: 'Le contrat n\'est pas accepté'
      }
    } else {
      return {
        color: 'success',
        icon: 'fa-check',
        text: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/contract.js